
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/context-hub/overview",
      function () {
        return require("private-next-pages/context-hub/overview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/context-hub/overview"])
      });
    }
  